import { TrashIcon } from "@heroicons/react/outline";
import { useContext } from "react";

import { DatasetEditorContext } from "../..";
import { DropdownMenuVariant } from "@/components/ui/DropdownMenu/types";

export const useDeleteDataset = ({
  setIsDiscarded,
}: {
  setIsDiscarded: (value: boolean) => void;
}) => {
  const {
    isDraft,
    isSavingDataset,
    handleDeleteClick,
    isDeletingDataset,
    isDeletingDatasetGroup,
  } = useContext(DatasetEditorContext);

  const handleOnDeleteClick = () => {
    setIsDiscarded(true);
    handleDeleteClick();
  };

  return {
    id: "delete-dataset",
    label: "Discard Draft",
    icon: TrashIcon,
    onClick: handleOnDeleteClick,
    shouldShow: isDraft && !isSavingDataset,
    isLoading: isDeletingDataset || isDeletingDatasetGroup,
    variant: DropdownMenuVariant.DESTRUCTIVE,
  };
};
